import { PERMISSION_LEVEL } from "@constants/permissionLevel";
import Spinner from "@legacy/core/components/Spinner";
import { AccessCheck } from "@particles/index";
import { Component } from "react";
import UniversalButton from "../../core/buttons/UniversalButton";
import { formatCurrencyForServiceCompany, formatLocalTime } from "../../core/utils/utils";


class BillVendorCreditApplicationList extends Component {

    constructor() {
        super()

        this.state = {
            applications: null,
        }
    }

    fetchApplications = async () => {
        const response = await fetch(this.props.endpoint)
        return await response.json()
    }

    componentDidMount = async () => {
        const applicationsList = await this.fetchApplications()
        this.setState({ applications: applicationsList })
    }

    render = () => {
        const { object, isUnapplying, onUnapply } = this.props

        if (this.state.applications === null) {
            return (
                <div className="data-panel__form__field__display-list">
                    <Spinner centered={true} />
                </div>
            )
        }

        return (
            <div className="data-panel__form__field__display-list" aria-label="Vendor Credit Application List">
                {this.state.applications.map(
                    (application) => {
                        return (
                            <div key={application.id} className="data-panel__form__field__display-list__object payment-display" aria-label="Vendor Credit Application">
                                <div className="payment-display__row">
                                    <div className="payment-display__field" aria-label="Vendor Credit">
                                        <div className="payment-display__field-label" aria-hidden="true">Vendor Credit</div>
                                        <div className="payment-display__field-value">
                                            <a href={DjangoUrls["bills:vendor-credits-detail"](window.MARKETPLACE_ENTITY_SLUG, application.vendor_credit_id)}>
                                                {application.vendor_credit_custom_id || application.vendor_credit_id}
                                            </a>
                                        </div>
                                    </div>
                                    <div className="payment-display__field" aria-label="Date Applied">
                                        <div className="payment-display__field-label" aria-hidden="true">Date Applied</div>
                                        <div className="payment-display__field-value" aria-label="Date Applied">
                                            {formatLocalTime(application.created_at, object.service_company.preferred_timezone, true, false, false, true).localDateString}
                                        </div>
                                    </div>
                                    <div className="payment-display__field" aria-label="Amount">
                                        <div className="payment-display__field-label" aria-hidden="true">Amount</div>
                                        <div className="payment-display__field-value" aria-label="Amount">
                                            {formatCurrencyForServiceCompany(application.amount * -1, object.service_company)}
                                        </div>
                                    </div>
                                </div>
                                <AccessCheck permissions={{
                                    bills_delete_permission: PERMISSION_LEVEL.FULL
                                }}>
                                    <div className="payment-display__row credit-allocation-reverse-row">
                                        <UniversalButton type="danger" text="Unapply" disabled={isUnapplying} handler={() => onUnapply(application)} />
                                    </div>
                                </AccessCheck>
                            </div>
                        )
                    }
                )}
            </div>
        )
    }
}

export default BillVendorCreditApplicationList;
